import { FC } from "react";
import { COLOR_WHITE } from "../colors";
import { IconType } from "./types";

export const NumericListIcon: FC<IconType> = ({ color = COLOR_WHITE }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 21H9V21.5H8V22.5H9V23H7V24H10V20H7V21ZM8 12H9V8H7V9H8V12ZM7 15H8.8L7 17.1V18H10V17H8.2L10 14.9V14H7V15ZM12 9V11H26V9H12ZM12 23H26V21H12V23ZM12 17H26V15H12V17Z"
      fill={color}
    />
  </svg>
);
